var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1681796500507,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2658,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M889.6 489.685333c40.789333-24.917333 91.733333 6.186667 91.733333 55.893334v262.528c0 49.792-51.072 80.896-91.861333 55.978666l-76.117333-46.336v30.08c0 49.92-38.698667 90.837333-86.101334 90.837334H128.768C81.493333 938.666667 42.666667 897.834667 42.666667 847.786667v-372.906667C42.666667 424.96 81.365333 384 128.768 384h598.613333c47.274667 0 86.058667 40.832 86.058667 90.88v61.141333l76.117333-46.336z m-502.784 27.477334c-20.138667-14.677333-45.354667 3.669333-45.482667 33.024v222.165333c0 29.482667 25.344 47.786667 45.482667 33.152l152.746667-111.104c20.138667-14.677333 20.138667-51.456 0-66.133333l-152.746667-111.104zM341.333333 256a85.333333 85.333333 0 1 1-170.666666 0 85.333333 85.333333 0 0 1 170.666666 0M597.333333 341.333333a128 128 0 1 0 0.042667-255.957333A128 128 0 0 0 597.333333 341.333333z",
    "p-id": 2659,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.4cc718dd.svg";
export { ForwardRef as ReactComponent };